module.exports = __webpack_public_path__ + "static/allegations_of_abuse.cb46a4f5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/policies/allegations_of_abuse.pdf
// module id = 324
// module chunks = 177890977751730